module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_watch_1230a38b016206b0f121c0d2a2ba3c15.png";